import { classNames } from '@panwds/tailwindcss';
import React, { useEffect, useRef, useState } from 'react';
import { StepConnector } from './StepConnector.js';
import { StepIcon } from './StepIcon.js';
import { useStepItemContext } from './StepItemContext.js';
import { useStepperContext } from './StepperContext.js';
export const StepContent = ({ label, content, as: Component = 'div', addClassName, size = 'sm', onClick }) => {
    const { direction, spacing = 'tw-w-40', vSpacing = 'tw-h-12' } = useStepperContext();
    const { last, stepNumber, status, disabled } = useStepItemContext();
    const isVertical = direction === 'vertical';
    const buttonRef = useRef(null);
    const [buttonBox, setButtonBox] = useState({ width: 0, height: 0 });
    useEffect(() => {
        const box = buttonRef.current?.getBoundingClientRect() || { width: 0, height: 0 };
        setButtonBox(box);
    }, [size, status]);
    return (React.createElement(Component, { className: classNames('tw-my-0 tw-text-sm tw-text-gray-700 dark:tw-text-gray-100', isVertical && 'tw-flex tw-ml-1 tw-h-full', addClassName) },
        React.createElement("div", { className: classNames('tw-flex tw-my-0 tw-text-sm', !isVertical ? 'tw-relative' : 'tw-flex-col'), style: !isVertical ? { left: `calc(50% - ${buttonBox['width'] / 2}px)` } : {} },
            React.createElement(StepIcon, { size: size, status: status, stepNumber: stepNumber, onClick: onClick, refProp: buttonRef, disabled: disabled }),
            !last && React.createElement(StepConnector, null)),
        React.createElement("div", { className: classNames(disabled && 'tw-opacity-40', !isVertical
                ? `tw-text-center tw-m-auto tw-px-5 tw-min-w-30 ${spacing}`
                : `tw-ml-1.5 tw-leading-4 tw-min-h-6 ${vSpacing}`) },
            React.createElement("span", { className: "tw-m-0 tw-font-semibold tw-flex tw-flex-col tw-justify-center", style: {
                    minHeight: isVertical && buttonBox['height'] ? buttonBox['height'] : 'auto'
                } }, label),
            React.createElement("span", { className: classNames('tw-m-0 tw-text-xs tw-text-gray-500 dark:tw-text-gray-300 tw-block') }, content))));
};
//# sourceMappingURL=StepContent.js.map